export default subscription => !!subscription.master_subscription_id
